

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"
import DataForm from "../DataForm.vue"
import { TemplateDetails, Field, Tag, DataType, CalculationDataTypeValue, CalculationType, Team, Template } from "@/types"
import api from "@/services/api.ts"

const setup = namespace("setup")

@Component({
	components: {
		"data-form": DataForm
	}
})
export default class TemplateCadence extends Vue {
	@Prop()
	public template!: TemplateDetails

	@Prop({ type: Boolean, default: true })
	public canEdit!: boolean;

	@setup.Getter("getTeams")
	teams!: Team[];

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	@Prop({ default: () => [] })
	private templates!: Template[];

	public async mounted () {
		if (this.template) {
			var cadenceDetails = this.template.cadenceDetails
			Vue.set(cadenceDetails!, "disablePermissionsTeams", cadenceDetails!.disablePermissions ? this.teams.filter(t => cadenceDetails!.disablePermissions.some(ut => ut.id === t.id)) : [])
		}
	}

	public get columns (): any[] {
		if (!this.template) {
			return []
		}

		return [
			{
				key: "cadenceTemplateId",
				label: "Template",
				dataType: "list",
				valueColumn: "cadenceTemplateId",
				options: this.templates,
				inModal: (item: any) => true,
				inTable: false,
				placeholder: "Current Template"
			},
			{
				key: "cadenceFields",
				label: "Fields",
				dataType: "list-multiple",
				valueColumn: "cadenceFields",
				options: this.avaliableCadenceFields,
				inModal: (item: any) => true,
				inTable: false
			},
			{
				key: "isCase",
				label: "Keep promoted status",
				dataType: "checkbox",
				valueColumn: "isCase",
				inModal: (item: any) => true,
				inTable: false,
				tooltip: `When enabled transfer promoted status over to new cadence ${this.getRecordName}/${this.getCaseName}.`
			},
			{
				key: "cadencePeriod",
				label: "Period(Days)",
				dataType: "number",
				valueColumn: "cadencePeriod",
				errors: (item: any) => (item.cadencePeriod >= 0) ? null : "Please enter a positive number",
				componentProperties: {
					precision: 0
				}
			},
			{
				key: "disablePermissions",
				hasTemplate: true,
				label: "Disable Permissions",
				dataType: "list-multiple",
				valueColumn: "disablePermissionsTeams",
				options: this.teams,
				inTable: false,
				placeholder: "Any"
			}
		]
	}

	/**
	 * List of all the built in fields that can be used for cadence
	 */
	public get builtInFields (): any[] {
		if (!this.template) {
			return []
		}

		return [
			{
				id: "title",
				title: "Title"
			},
			{
				id: "summary",
				title: "Summary"
			},
			{
				id: "severity",
				title: "Severity"
			},
			{
				id: "areas",
				title: "Affected Areas"
			},
			{
				id: "tags",
				title: "Tags"
			}
		]
	}

	/**
	 * List of all the fields added to the template
	 */
	get addedFields () {
		var fields : any[] = []

		if (this.template) {
			this.template.fields.forEach(f => {
				var field :any = { id: f.field.id, title: f.field.title, description: f.field.description }
				fields.push(field)
			})
		}
		return fields
	}

	/**
	 * List of all fields that can be used for cadence
	 * Ensure no null fields are included.
	 */
	get avaliableCadenceFields () {
		return this.builtInFields.concat(this.addedFields).filter(field => !!field)
	}
}

